export const INNO_AVAILABLE_PROPERTIES = ["merk", "koudemiddel"];
export const INNO_HIDE_PROPERTIES = ["saleslayer_new_product", "is_baseproduct", "order_unit"];

export const COC_NUMBER_PROP = "coc_number";
export const VAT_NUMBER_PROP = "vat_number";
export const COMPANY_NAME_PROP = "organization_name";

export const INNO_EXTRA_SERVICES_LIST = ["VLD-G-107", "VLD-G-115", "VLD-G-116"];

export const SPOTLER_KEY_PROP = "Spotler key";
export const SPOTLER_SECRET_PROP = "Spotler secret";
